const HK_TIMEZONE = 'Asia/Hong_Kong'

function getHongKongToday() {
  const hkDateStr = new Date().toLocaleDateString('en-CA', { timeZone: HK_TIMEZONE })
  const [year, month, day] = hkDateStr.split('-').map(Number)
  return new Date(year, month - 1, day)
}

/**
 * The Sunday shown on the public page:
 * - All day Sunday → that Sunday
 * - Mon–Sat → the next upcoming Sunday (rolls over Monday morning HK time)
 */
export function getDisplaySundayDateStr() {
  const today = getHongKongToday()
  const dayOfWeek = today.getDay()

  const displaySunday = dayOfWeek === 0
    ? today
    : new Date(today.getFullYear(), today.getMonth(), today.getDate() + (7 - dayOfWeek))

  const year = displaySunday.getFullYear()
  const month = String(displaySunday.getMonth() + 1).padStart(2, '0')
  const day = String(displaySunday.getDate()).padStart(2, '0')
  return `${year}${month}${day}`
}

function parseYmd(dateStr) {
  const year = parseInt(dateStr.substring(0, 4), 10)
  const month = parseInt(dateStr.substring(4, 6), 10) - 1
  const day = parseInt(dateStr.substring(6, 8), 10)
  return new Date(year, month, day)
}

function formatYmd(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}${month}${day}`
}

/** Recent Sunday dates for speaker upload (newest first). */
export function getRecentSundayDateStrs(count = 6) {
  const dates = []
  let current = parseYmd(getDisplaySundayDateStr())
  for (let i = 0; i < count; i++) {
    dates.push(formatYmd(current))
    current = new Date(current.getFullYear(), current.getMonth(), current.getDate() - 7)
  }
  return dates
}

/**
 * Upcoming Sundays for future event entry (Hong Kong timezone).
 * - nextSunday: coming Sunday (today if today is Sunday)
 * - nextNextSunday: +1 week
 * - nextNextNextSunday: +2 weeks
 */
export function getUpcomingSundayOptions() {
  const nextSunday = parseYmd(getDisplaySundayDateStr())
  const nextNextSunday = new Date(
    nextSunday.getFullYear(),
    nextSunday.getMonth(),
    nextSunday.getDate() + 7
  )
  const nextNextNextSunday = new Date(
    nextSunday.getFullYear(),
    nextSunday.getMonth(),
    nextSunday.getDate() + 14
  )
  return {
    nextSunday: formatYmd(nextSunday),
    nextNextSunday: formatYmd(nextNextSunday),
    nextNextNextSunday: formatYmd(nextNextNextSunday)
  }
}

export function formatDateDisplay(dateStr, lang = 'zh') {
  if (!dateStr || dateStr.length !== 8) return dateStr
  const y = dateStr.substring(0, 4)
  const m = dateStr.substring(4, 6)
  const d = dateStr.substring(6, 8)
  const dayOfWeek = parseYmd(dateStr).getDay()
  const days = lang === 'zh'
    ? ['日', '一', '二', '三', '四', '五', '六']
    : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  return `${y}-${m}-${d} (${days[dayOfWeek]})`
}
